import React, { ComponentPropsWithoutRef, useState } from 'react'
import AACChromeInternalAPI from '@amzn/aac-chrome-internal-api'
import { AdvertisingLogoContainer, Headline, SecondaryView, HeaderWrapper, CarouselSlideContainer } from './style'
import { useEmitInitialRender } from '../../../utils/hooks'
import { LaunchModalProps } from '..'
import { dismissWidget } from '../../../utils/functions'
import { WidgetTypes } from '../../../common/constants'
import { SecondaryViewContent, StickyHeaderWrapper } from '../../FeatureModal/MobileFeatureModal/style'
import Carousel from './Carousel'

export const MobileLaunchModal: React.VFC<LaunchModalProps> = ({ previousButtonText = 'previous', nextButtonText = 'next', anchorId, slides, slidesDuration, message, logo, dataTaktId }) => {
  useEmitInitialRender(WidgetTypes.MobileLaunchModal)

  const closeButtonLabel = AACChromeInternalAPI.getChromeContext().featureLaunchInfo?.features?.find((feature) => feature.name === 'FIT_LOAD_DELAY')?.content?.fitBack
  const [headerHeight, setHeaderHeight] = useState<string>()
  const setHeaderRef = (headerNode) => {
    if (headerNode) setHeaderHeight(window.getComputedStyle(headerNode).height)
  }
  const setContentRefStyles = (contentNode) => {
    if (contentNode && headerHeight) contentNode.style.paddingTop = headerHeight
  }

  const [isOpen, setIsOpen] = useState(true)
  const onModalClose = () => {
    dismissWidget(anchorId)
    setIsOpen(false)
  }

  return (
    <SecondaryView
      data-takt-id={dataTaktId}
      isOpen={isOpen}
      onClose={onModalClose}
      secondaryViewElementId="AACChromePortal"
      padding="none"
      closeButtonLabel={closeButtonLabel}
      closeButtonProps={{ 'data-takt-id': `${dataTaktId}_close-button` } as unknown as ComponentPropsWithoutRef<'button'>}
    >
      <SecondaryViewContent>
        <StickyHeaderWrapper ref={setHeaderRef}>
          <HeaderWrapper>
            {logo && <AdvertisingLogoContainer src={logo.link} alt={logo.altText} />}
            <Headline type="h4" hasLogo={!!logo}>
              {message}
            </Headline>
          </HeaderWrapper>
        </StickyHeaderWrapper>
        <CarouselSlideContainer ref={setContentRefStyles} />
        <Carousel
          ariaLabels={{
            previous: previousButtonText,
            next: nextButtonText,
          }}
          slides={slides}
          slidesDuration={slidesDuration}
          dataTaktId={dataTaktId}
        />
      </SecondaryViewContent>
    </SecondaryView>
  )
}
